import React from 'react'
import Address from '../shared/address'
import Search from '../support/searchbar'
import Help from '../support/help-topics'
import Questions from '../support/questions'
import Answers from '../support/answers'
import { fetchFaqLinks, fetchAllFaqQuestions, fetchFaqQuestion } from '../api'
import * as RB from 'react-bootstrap'

var helpTopics = []
var mobileHeader = '/common/latest/images/consumer/support/support-mobile-header.png'
let headerTitle

export default React.createClass({

  getInitialState: function () {
    return {
      data: '',
      address: '',
      answer: '',
      page: 0
    }
  },
  componentWillMount: function () {
    this.refreshPage(this.props)
    fetchFaqLinks().then((info) => {
      for (let i = 0; i < info.length; i++) {
        if (helpTopics.length < 5) {
          helpTopics.push(info[i])
        }
      }
      fetchAllFaqQuestions(info[0].category).then((info) => {
        let questionsAndAnswers = []
        for (let i = 0; i < info.length; i++) {
          questionsAndAnswers.push(info[i])
        }
        this.setState({ data: questionsAndAnswers, page: 0 })
      })
    })
  },
  refreshPage: function (props) {
    let address = props.currentAddress
    if (address != null) {
      let { addressId } = address
      if (addressId) this.setState({ currentlySelectedAddressId: addressId })
    }
  },
  getQuestions: function (helpTopicName) {
    headerTitle = helpTopicName
    fetchAllFaqQuestions(helpTopicName).then((info) => {
      let questionsAndAnswers = []
      for (let i = 0; i < info.length; i++) {
        questionsAndAnswers.push(info[i])
      }
      this.setState({ data: questionsAndAnswers, page: 1 })
    })
    document.getElementById('help').className += ' hidden'
    document.getElementById('questions').classList.remove('hidden')
  },
  showAnswers: function (answer) {
    this.setState({ answer: answer, page: 2 })
    document.getElementById('questions').className += ' hidden'
    document.getElementById('answers').classList.remove('hidden')
  },
  goBack: function () {
    if (this.state.page === 2) {
      document.getElementById('answers').className += ' hidden'
      document.getElementById('questions').classList.remove('hidden')
      this.setState({ page: 1 })
    } else if (this.state.page === 1) {
      document.getElementById('questions').className += ' hidden'
      document.getElementById('help').classList.remove('hidden')
      this.setState({ page: 0 })
    }
  },
  searchForQuestion: function (question) {
    let questionsAndAnswers = []

    fetchFaqQuestion(question).then((data) => {
      for (let i = 0; i < data.data.length; i++) {
        questionsAndAnswers.push(data.data[i])
      }
      if (this.mobilecheck() === true) {
        headerTitle = question
        this.setState({ data: questionsAndAnswers, page: 1 })
        document.getElementById('help').className += ' hidden'
        document.getElementById('questions').classList.remove('hidden')
      } else {
        this.setState({ data: questionsAndAnswers })
      }
    })
  },
  mobilecheck: function () {
    var check = false
    if (window.innerWidth <= 767 && window.innerHeight <= 866) {
      check = true
    } else {
      check = false
    }
    return check
  },
  render: function () {
    let customerAddresses = []
    for (let i = 0; i < this.props.loginData.customer.addresses.length; i++) {
      let addressData = this.props.loginData.customer.addresses[i]
      let customerAddress = addressData.streetAddress + ', ' + addressData.city
      customerAddresses.push(customerAddress)
    }
    let header
    if (this.state.page === 0) {
      header = <div className='support-mobile-header text-center' style={{
        marginTop: -22,
        backgroundImage: 'url(' + mobileHeader + ')',
        height: 140,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        padding: 20
      }}>
        <h4 style={{ color: 'white', fontSize: 32, fontWeight: 500 }}>Support</h4>
        <div style={{ width: '100%', margin: 'auto' }}>
          <Search search={this.searchForQuestion}/>
        </div>
      </div>
    } else if (this.state.page === 1) {
      let newHeader = headerTitle.charAt(0).toUpperCase() + headerTitle.substr(1).toLowerCase()
      newHeader = newHeader.replace(/_/g, ' ')
      header = <div className='support-mobile-header' style={{ marginTop: -22, background: '#ececec', height: 90 }}>
        <div style={{
          height: 30,
          width: 30,
          borderRadius: '100%',
          background: 'white',
          textAlign: 'canter',
          position: 'relative',
          left: 19,
          top: 33
        }}>
          <i style={{ position: 'relative', top: '4px', left: '7px' }} onClick={() => this.goBack()}
             className="fa fa-arrow-left"></i>
        </div>
        <h4 style={{ textAlign: 'center' }}>{newHeader}</h4>
      </div>
    } else {
      header = <div style={{
        height: 30,
        width: 30,
        borderRadius: '100%',
        background: 'white',
        textAlign: 'canter',
        position: 'relative',
        left: 19,
        top: 0
      }}>
        <i style={{ position: 'relative', top: '4px', left: '7px' }} onClick={() => this.goBack()}
           className="fa fa-arrow-left"></i>
      </div>
    }

    return (
      <RB.Grid className='container-cards' name='top'>
        <RB.Row>
          <RB.Col xs={12} className='history-wrap hidden-xs'>
            <RB.Row className='pull-down-sm-1'>
              <RB.Col sm={5} xs={12}>
                <h3 className='hidden-xs' style={{ textAlign: 'left' }}>Support</h3>
                <h3 className='visible-xs'>Support</h3>
              </RB.Col>
              <RB.Col sm={7} xs={12} className='text-right address'>
                <Address addresses={customerAddresses} curIndex={this.props.curAddressIndex}
                         onChange={this.props.reportAddressChange}/>
              </RB.Col>
            </RB.Row>
            <RB.Col xs={12} sm={12} style={{ marginTop: '20px' }}>
              <Search search={this.searchForQuestion}/>
            </RB.Col>
          </RB.Col>

          <RB.Row className='visible-xs'>
            {header}
            <RB.Col xs={12} sm={12} id='help' style={{ padding: 0, background: 'white' }}>
              <Help data={helpTopics} getQuestons={(e) => this.getQuestions(e)}/>
            </RB.Col>
            <RB.Col xs={12} sm={12} className='hidden' id='questions' style={{ marginTop: 20, padding: 0 }}>
              <Questions data={this.state.data} showAnswers={(e) => this.showAnswers(e)}/>
            </RB.Col>
            <RB.Col xs={12} sm={12} className='hidden' id='answers' style={{ marginTop: 20, padding: 0 }}>
              <Answers data={this.state.answer}/>
            </RB.Col>
          </RB.Row>

          <RB.Row className='hidden-xs'>
            <RB.Col xs={4} sm={4} style={{ padding: 0 }}>
              <RB.Row>
                <RB.Col xs={12} sm={12}>
                  <Help data={helpTopics} getQuestons={(e) => this.getQuestions(e)}/>
                </RB.Col>
              </RB.Row>
            </RB.Col>
            <RB.Col xs={8} sm={8}>
              <RB.Row>
                <RB.Col xs={12} sm={12} style={{ marginTop: 20, padding: 0 }}>
                  <Questions data={this.state.data} full={true} showAnswers={(e) => this.showAnswers(e)}/>
                </RB.Col>
              </RB.Row>
            </RB.Col>
          </RB.Row>
        </RB.Row>
      </RB.Grid>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/support/support.jsx